import request from '@/utils/request'

// 获取合同图片等信息
export function getSignInfoWithSeal(data) {
	return request({
		url: '/api/common/v1/open/getSignInfoWithSeal',
		method: 'post',
		data
	})
}

// 提交签署信息
export function signWithPosition(data) {
	return request({
		url: '/api/common/v1/open/signWithPosition',
		method: 'post',
		data
	})
}


